import api from './api'
import type { PricingItem } from '@/types'

interface CreatePricingItemPayload {
  name: string
  unit: string
  rate: number
  description?: string
  category: string
  // Category-specific
  service?: string
  fuelCharge?: number
  overtimeRate?: number
  publicWorksRate?: number
  variableCost?: boolean
  restripeCost?: number
  newLayoutEnabled?: boolean
  doubleCoatEnabled?: boolean
  newLayoutAdditionalCost?: number
  doubleCoatAdditionalCost?: number
  stripingCategory?: string
  serviceRates?: Record<string, { rate: number; overtimeRate: number; publicWorksRate: number }>
}

interface UpdatePricingItemPayload {
  name?: string
  unit?: string
  rate?: number
  description?: string
  isActive?: boolean
  service?: string
  fuelCharge?: number
  overtimeRate?: number
  publicWorksRate?: number
  variableCost?: boolean
  restripeCost?: number
  newLayoutEnabled?: boolean
  doubleCoatEnabled?: boolean
  newLayoutAdditionalCost?: number
  doubleCoatAdditionalCost?: number
  stripingCategory?: string
  serviceRates?: Record<string, { rate: number; overtimeRate: number; publicWorksRate: number }>
}

export const pricingService = {
  async list(category?: string) {
    const params = category ? `?category=${category}` : ''
    const { data } = await api.get(`/pricing${params}`)
    return data.data as PricingItem[]
  },

  async getById(id: string) {
    const { data } = await api.get(`/pricing/${id}`)
    return data.data as PricingItem
  },

  async create(payload: CreatePricingItemPayload) {
    const { data } = await api.post('/pricing', payload)
    return data.data as PricingItem
  },

  async update(id: string, payload: UpdatePricingItemPayload) {
    const { data } = await api.put(`/pricing/${id}`, payload)
    return data.data as PricingItem
  },

  async remove(id: string) {
    await api.delete(`/pricing/${id}`)
  },

  async importItems(items: CreatePricingItemPayload[]) {
    const { data } = await api.post('/pricing/import', { items })
    return data.data as PricingItem[]
  },
}
